import { Col, Row } from '@advanza/advanza_generic'
import React from 'react'

const SalesLeadProvider = ({ provider, providerEntities }) => {
    const { users } = providerEntities
    const user = users[provider.user]
    const tableMap = [
        { key: 'first_name', name: 'First name' },
        { key: 'last_name', name: 'Last name' },
        { key: 'email', name: 'Email', item: <a href={`mailto:${user.email}`}>{user.email}</a> },
        { key: 'phone', name: 'Phone' },
    ]
    return (
        <div>
            {tableMap.map(({ key, name, item }) => {
                const answer = item || provider[key] || user[key]
                if (answer) {
                    return (
                        <Row key={name} y="min">
                            <Col c={4}>{name}</Col>
                            <Col c={8}>
                                <b>{answer}</b>
                            </Col>
                        </Row>
                    )
                }
            })}
        </div>
    )
}

export default SalesLeadProvider
